






helpers = require('../../../helpers.coffee')

view_model = {
  components:
    notificationListItem: require('./list_item')

  data: ->
    notifications: []

	methods:
		addNotification: (notif) ->
      notification = new Notification()
      notification.id = notif.id
      notification.user_id = notif.user_id
      notification.count = notif.count
      notification.kind = notif.kind
      notification.created_at = moment(notif.created_at).toDate()
      notification.updated_at = moment(notif.updated_at).toDate()
      notification.contact_name = notif.contact_name if notif.contact_name
      notification.flow_name = notif.flow_name if notif.flow_name
      notification.task_due_on = notif.task_due_on if notif.task_due_on
      notification.metadata = notif.metadata if notif.metadata

      @addOrReplaceNotification(notification)
      @$store.commit 'addOrReplaceNotification', notification

    addOrReplaceNotification: (notification) ->
      if @notifications.find(notification.id)
        @notifications.replaceById(notification)
      else
        @notifications.unshift(notification)

    removeNotification: (id, markAsRead=true) ->
      @notifications_resource.read(null, @unknownError, { id }) if markAsRead
      @notifications.remove(id)

		subscribeToNotificationChannel: ->
      @removeNotificationSubscription()
      @notification_subscription = ActionCable.cable.subscriptions.create { channel: 'NotificationChannel', user_id: Session.current_user.id },
        received: (event_data) =>
          @addNotification(event_data)

    removeNotificationSubscription: ->
      ActionCable.cable.subscriptions.remove(@notification_subscription) if @notification_subscription
      @notification_subscription = null

	created: ->
		@notifications_resource = new NotificationsResource()
		@notification_subscription = null
		@subscribeToNotificationChannel()

	beforeDestroy: ->
    @removeNotificationSubscription()
}

exports.default = helpers.vue_include(view_model)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/notifications/popup.vue